const IframeOptionsEnum = {
    FullScreen: 0,
    HeaderFooter: 1,
    QuickActionsBar: 2
}

export default IframeOptionsEnum;